"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const styles_1 = require("@material-ui/core/styles");
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const react_form_renderer_1 = require("@data-driven-forms/react-form-renderer");
const styles_2 = require("@material-ui/core/styles");
const FormField_1 = __importDefault(require("../../../FormField"));
const Text_1 = __importDefault(require("../../../Text"));
const Button_1 = __importDefault(require("../../../Button"));
const Stack_1 = __importDefault(require("../../../../layouts/Stack"));
const FieldArrayItem_1 = __importDefault(require("./components/FieldArrayItem"));
const getErrorText_1 = require("../../utils/getErrorText");
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const Container_1 = __importDefault(require("../../../../layouts/Container"));
const DEFAULT_BUTTON_LABELS = {
    add: 'Add new item',
    remove: 'Remove',
};
const useStyles = styles_2.makeStyles({
    grid: {
        marginTop: '-10px',
        '&>*': {
            marginTop: '10px',
        },
    },
});
const FieldArrayMapping = (props) => {
    const _a = use_field_api_1.default(props), { arrayValidator, label, description, helperText, fields: formFields, defaultItem = {}, showError, meta: { submitFailed, error }, layout, displayLablePerItem = false, minItems = 0, maxItems = Number.MAX_SAFE_INTEGER, buttonLabels, renderContainer = false, noItemsMessage, validateOnMount, input, isReadOnly = false } = _a, rest = __rest(_a, ["arrayValidator", "label", "description", "helperText", "fields", "defaultItem", "showError", "meta", "layout", "displayLablePerItem", "minItems", "maxItems", "buttonLabels", "renderContainer", "noItemsMessage", "validateOnMount", "input", "isReadOnly"]);
    const controlId = useUniqueId_1.default(input.name);
    const errorText = getErrorText_1.getErrorText(validateOnMount, submitFailed, showError, error);
    const renderedButtonLabels = Object.assign(Object.assign({}, DEFAULT_BUTTON_LABELS), buttonLabels);
    const theme = styles_1.useTheme();
    const matched = useMediaQuery_1.default(theme.breakpoints.down('xs'));
    const styles = useStyles();
    const testId = rest['data-testid'] || 'form-array';
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, label: label, description: description, hintText: helperText, errorText: errorText, "data-testid": testId },
        react_1.default.createElement(react_form_renderer_1.FieldArray, { key: controlId, name: controlId, validate: arrayValidator }, ({ fields }) => {
            const { length, map, push, remove } = fields;
            return (react_1.default.createElement(Stack_1.default, { spacing: "s" },
                length === 0 && react_1.default.createElement(Text_1.default, null, noItemsMessage),
                map((name, index) => {
                    const item = (react_1.default.createElement(FieldArrayItem_1.default, { gridStyle: styles.grid, layout: layout, key: `Item-${name}`, fields: formFields, name: name, fieldIndex: index, showError: showError, displayLablePerItem: displayLablePerItem, onRemove: remove, length: length, minItems: minItems, removeLabel: renderedButtonLabels.remove, isReadOnly: isReadOnly, collapse: layout === 'stack' || matched, "data-testid": `${testId}-${name}` }));
                    return renderContainer ? react_1.default.createElement(Container_1.default, { key: `Container-${name}` }, item) : item;
                }),
                !isReadOnly && (react_1.default.createElement(Button_1.default, { onClick: () => push(defaultItem), disabled: !!length && length >= maxItems, "data-testid": `${testId}-add-button` }, renderedButtonLabels.add))));
        })));
};
exports.default = FieldArrayMapping;
//# sourceMappingURL=index.js.map